import {
  clearPersistedAuthStorage,
  clearTokenCookiesClientSide,
} from './clear-session';
import { FORCE_LOGIN_KEY } from './client-constants';
import { clearWebinappToken } from './webinapp-token';
import { clearAuthCache, useNewAuthStore } from '@/store/use-new-auth-store';

let loggingOut = false;

/**
 * Terminal logout — gọi khi API trả 401 trên WEB session (token JWT hết hạn).
 *
 * KHÔNG còn refresh chain (đã bỏ): token webAhamove sống 3 ngày, refresh runtime
 * không dùng nữa. 401 = phiên thật sự hết hạn → logout dứt điểm.
 *
 * Hành vi:
 *   1. Clear store + auth cache + persisted storage.
 *   2. Xóa cookie CLIENT-SIDE ĐỒNG BỘ (token/refresh_token/auth_state + webinapp
 *      token) — KHÔNG chỉ dựa vào fetch('/api/auth/logout') async. Đây là điểm
 *      diệt loop tận gốc: nếu cookie chưa xóa kịp trước reload → hydrate thấy
 *      token còn → tưởng đã đăng nhập → gọi API → 401 → logout → reload... (loop).
 *   3. Báo cho user (toast) biết phiên hết hạn.
 *   4. Về trang chủ (same-origin) để UI về trạng thái đã đăng xuất → re-login.
 *
 * Idempotent: nhiều request 401 song song chỉ logout 1 lần (tránh toast/redirect lặp).
 * CHỈ dùng cho web (có refresh_token). Webinapp giữ phiên — KHÔNG gọi hàm này.
 */
export function terminalLogout() {
  if (loggingOut || typeof window === 'undefined') return;
  loggingOut = true;

  try {
    useNewAuthStore.getState().logout();
    clearAuthCache();

    // Xóa cookie + persist ĐỒNG BỘ trước redirect (fix loop). fetch logout bên
    // dưới chỉ còn là backup cho cookie server-side scope.
    clearTokenCookiesClientSide();
    clearWebinappToken();
    clearPersistedAuthStorage();

    try {
      // Ép lần login kế tiếp hiện form (prompt=login) thay vì silent SSO account cũ.
      localStorage.setItem(FORCE_LOGIN_KEY, '1');
    } catch {
      /* ignore */
    }

    // Backup: clear cookie ahafood server-side (đúng Domain=.ahafood.ai scope).
    void fetch('/api/auth/logout', { method: 'POST' });

    void import('sonner').then(({ toast }) => {
      toast.error('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.');
    });

    // Cho toast kịp hiển thị trước khi điều hướng về trang chủ.
    window.setTimeout(() => {
      window.location.replace('/');
    }, 1200);
  } catch {
    /* best-effort cleanup */
  }
}
